import { TableHeader, Pagination, Search } from '../Table';
import React, { useState, useEffect, useMemo } from 'react';
import Loader from '../include/Loader';
import Menu from '../include/Menu';
import Footer from '../include/Footer';
import { Button, CloseButton, Dropdown, Form, Modal, Table } from 'react-bootstrap';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import HistoryIcon from '@material-ui/icons/History';
import axios from 'axios';
import { toast } from 'react-toastify';
import Spinner from '../include/Spinner';
import moment from 'moment';
import SweetAlert from "react-bootstrap-sweetalert";
import { handleLogout } from '../../../config';

export default function PromoCode() {
  const [entity, setEntity] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');
  const [sorting, setSorting] = useState({ field: '', order: '' });
  const [limit, setlimit] = useState(10);
  const [Loading, setLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [selectedPromoId, setSelectedPromoId] = useState(null);

  const [showUsagesModal, setShowUsagesModal] = useState(false);
  const [usagesLoading, setUsagesLoading] = useState(false);
  const [usagesData, setUsagesData] = useState([]);
  const [usagesPromoCode, setUsagesPromoCode] = useState(null);
  const navigate = useNavigate();


  const [formData, setFormData] = useState({
    promoCode: '',
    discount: '',
    discountType: 'Percentage',
    foundation: '',
    expiryDate: '',
    startDate: '',
    promoType: '1', // Default to General
  });

  const userHeader = [
    {
      name: 'Sr. No.',
      field: 'id',
      sortable: false,
    },
    {
      name: 'Code',
      // field: "",
      sortable: false,
    },
    {
      name: 'Discount',
      // field: "",
      sortable: false,
    },
    {
      name: 'Foundation',
      // field: "",
      sortable: false,
    },
    {
      name: 'Total Donations',
    },
    {
      name: 'Total Discounts',
    },
    {
      name: 'Start Date',
      // field: "",
      sortable: false,
    },
    {
      name: 'End Date',
      // field: "",
      sortable: false,
    },
    {
      name: 'Action',
      sortable: false,
    },
  ];

  const commentsData = useMemo(() => {
    let computedComments = entity;

    if (search) {

      computedComments = computedComments.filter(
        (claims) =>
          claims?.promoCode?.toLowerCase()?.includes(search?.toLowerCase()) ||
          claims?.foundation?.toLowerCase()?.includes(search?.toLowerCase())
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === 'asc' ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return computedComments?.slice(
      (currentPage - 1) * limit,
      (currentPage - 1) * limit + limit
    );
  }, [currentPage, search, sorting, limit, entity]);

  useEffect(() => {
    getPromoList();
    document.getElementById('page-loader').style.display = 'none';
    var element = document.getElementById('page-container');
    element.classList.add('show');
  }, []);

  const getPromoList = () => {
    const myurl = 'https://api.teleportanything.com/api/admin/promocode/list-promocodes';
    //const myurl = 'http://localhost:3000/api/admin/claim-request-list';
    var bodyFormData = new URLSearchParams();
    // bodyFormData.append('status', filterData.status);
    axios({
      method: 'get',
      url: myurl,
      data: bodyFormData,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', "ngrok-skip-browser-warning": "69420", 'Authorization': `Bearer ${localStorage.getItem('DM_Admin_TOKEN')}` },
    })
      .then(async (response) => {
        setDisable(false);
        if (response?.data?.success) {
          let data = await response?.data?.data?.map((e, i) => {
            return { ...e, sr_no: i + 1 };
          });
          setEntity(data);
        } else {
          toast.error('Something went wrong');
        }
        setLoading(false)
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.data?.code === 401) {
          handleLogout(navigate);
          return;
        }
        toast.error('Something went wrong');
        console.error("Errors", error);
        setLoading(false)
      });
  };

  const handleViewUsages = async (promo) => {
    setUsagesLoading(true);
    setShowUsagesModal(true);
    setUsagesPromoCode(promo.promoCode);
    try {
      const response = await axios.get(
        `https://api.teleportanything.com/api/admin/promocode/usages-promocode?coupon_id=${promo._id}`,
        {
          headers: {
            // Replace with your actual token logic
            'Authorization': `Bearer ${localStorage.getItem('DM_Admin_TOKEN')}`
          }
        }
      );
      if (response.data.success) {
        setUsagesData(response.data.data);
      } else {
        setUsagesData([]);
        toast.error('Failed to fetch usages');
      }
    } catch (err) {
      if (err?.response?.status === 401 || err?.response?.data?.code === 401) {
        handleLogout(navigate);
        return;
      }
      setUsagesData([]);
      toast.error('Error fetching usages');
    } finally {
      setUsagesLoading(false);
    }
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditMode(false);
    setFormData({
      promoCode: '',
      discount: '',
      discountType: 'Percentage',
      foundation: '',
      maxUsage: '',
      expiryDate: '',
      startDate: '',
      promoType: '1'
    });
    setShowUsagesModal(false);
    setUsagesData([]);
    setUsagesPromoCode(null);
    setSelectedPromoId(null);
    setModalLoading(false);
    setUsagesLoading(false);
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'promoType') {
      setFormData(prev => ({
        ...prev,
        [name]: value,
        foundation: ''
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!formData.promoCode || !formData.discount || !formData.expiryDate || !formData.startDate || (formData.promoType === '1' && !formData.foundation) || !formData.discountType || !formData.promoType) {
      toast.error('Please fill all required fields');
      return;
    }

    if (new Date(formData.startDate) >= new Date(formData.expiryDate)) {
      toast.error('Start date must be smaller than expiry date');
      return;
    }

    setModalLoading(true);

    try {
      const myurl = 'https://api.teleportanything.com/api/admin/promocode/create-promocode';
      var bodyFormData = new URLSearchParams();
      bodyFormData.append('promoCode', formData.promoCode);
      bodyFormData.append('discount', formData.discount);
      bodyFormData.append('discountType', formData.discountType);
      formData.foundation && bodyFormData.append('foundation', formData.foundation || null);
      bodyFormData.append('expiryTime', formData.expiryDate);
      bodyFormData.append('startTime', formData.startDate);
      bodyFormData.append('promoType', formData.promoType);

      if (editMode) {
        bodyFormData.append('id', selectedPromoId);
        const response = await axios({
          method: 'post',
          url: 'https://api.teleportanything.com/api/admin/promocode/update-promocode',
          data: bodyFormData,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            "ngrok-skip-browser-warning": "69420", 'Authorization': `Bearer ${localStorage.getItem('DM_Admin_TOKEN')}`
          },
        });

        if (response?.data?.success) {
          toast.success('Promo code updated successfully');
          getPromoList(); // Refresh the list after deletion
        } else {
          console.error('Error updating promo code');
          toast.error('Failed to update promo code');
        }
      } else {
        const response = await axios({
          method: 'post',
          url: myurl,
          data: bodyFormData,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            "ngrok-skip-browser-warning": "69420", 'Authorization': `Bearer ${localStorage.getItem('DM_Admin_TOKEN')}`
          },
        });

        if (response?.data?.success) {
          toast.success('Promo code created successfully');
          handleCloseModal();
          getPromoList(); // Refresh the list
        } else {
          toast.error('Failed to create promo code');
        }
      }
    } catch (error) {
      console.error("Error creating promo code:", error);
      if (error?.response?.status === 401 || error?.response?.data?.code === 401) {
        handleLogout(navigate);
        return;
      }
      toast.error('Something went wrong');
    } finally {
      setModalLoading(false);
      setShowModal(false);
      setEditMode(false);
      setFormData({
        promoCode: '',
        discount: '',
        discountType: 'Percentage',
        foundation: '',
        expiryDate: '',
        startDate: '',
        promoType: '1'
      });
      setSelectedPromoId(null);
      setLoading(false);
    }
  };

  const actionHandler = (e, id, item_description, status) => {
    e.target.blur();
    let msg;
    if (status == 0)
      msg = "Are you sure you want to decline the claim request?";
    else if (status == 2)
      msg = "Are you sure you want to accept the claim request?";
    if (window.confirm(msg)) {

      const myurl = "https://api.teleportanything.com/api/admin/accept-claim-request";
      //const myurl = "http://localhost:3000/api/admin/accept-claim-request";
      var bodyFormData = new URLSearchParams();
      bodyFormData.append('id', id);
      bodyFormData.append('status', status);
      bodyFormData.append('item_description', item_description);
      setLoading(true)

      axios({
        method: "post",
        url: myurl,
        data: bodyFormData,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': `Bearer ${localStorage.getItem('DM_Admin_TOKEN')}` },
      }).then((response) => {
        if (response.data.sucecess == true) {
          getPromoList();
          toast.success(status == 2 ? "Request accepted successfully" : "Request declined successfully");
        }
        setLoading(false)
      }).catch((error) => {
        if (error?.response?.status === 401 || error?.response?.data?.code === 401) {
          handleLogout(navigate);
          return;
        }
        console.error("Errors", error);
        setLoading(false)
      })
    }
  }

  const [disable, setDisable] = useState(false);
  const [filterData, setFilterData] = useState({
    status: ''
  });
  const handleInput = (e) => {
    ;
    const basicData = { ...filterData };
    basicData[e.target.name] = e.target.value;
    setFilterData(basicData);
  }
  const handleSearch = (e) => {
    setDisable(true);
    getPromoList();
  }

  const handleReset = () => {
    window.location.reload();
  }

  const handleDelete = (id) => {
    setSelectedPromoId(id);
    setShowDeleteAlert(true);
  };


  // const handleDelete = async (id) => {
  //   const formData = new FormData();
  //   formData.append('id', id);
  //   formData.append('isActive', 2);

  //   try {
  //     <SweetAlert
  //       warning
  //       showCancel
  //       confirmBtnText="Yes, delete it!"
  //       confirmBtnBsStyle="danger"
  //       title="Are you sure?"
  //       onConfirm={async () => {
  //         const response = await fetch('https://api.teleportanything.com/api/promocode/update-promocode', {
  //           method: 'POST',
  //           body: formData
  //         });

  //         if (response.ok) {
  //           toast.success('Promo code deleted successfully');
  //           getPromoList(); // Refresh the list after deletion
  //         } else {
  //           console.error('Error deleting promo code');
  //         }
  //       }}
  //       onCancel={() => setShowDeleteAlert(false)}
  //       focusCancelBtn
  //     />
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const handleEdit = (promo) => {
    // Open your edit form with `promo` details
    console.log('Edit promo:', promo);
    setFormData({
      promoCode: promo.promoCode,
      discount: promo.discount,
      discountType: promo.discountType,
      foundation: promo.foundation ? promo.foundation : '',
      expiryDate: moment(promo.expiryTime).format('YYYY-MM-DDTHH:mm'),
      startDate: moment(promo.startTime).format('YYYY-MM-DDTHH:mm'),
      promoType: promo.promoType.toString() // Ensure it's a string
    });
    setEditMode(true);
    setSelectedPromoId(promo._id);
    setShowModal(true);
  };

  return (
    <>
      <Loader />

      <div
        id="page-container"
        className="fade page-sidebar-fixed page-header-fixed"
      >
        <Menu />
        {showDeleteAlert && (
          <SweetAlert
            warning
            showCancel
            confirmBtnText="Yes, delete it!"
            confirmBtnBsStyle="danger"
            title="Are you sure?"
            onConfirm={async () => {
              const formData = new FormData();
              formData.append('id', selectedPromoId);
              formData.append('isActive', 2);

              try {
                const response = await fetch('https://api.teleportanything.com/api/admin/promocode/update-promocode', {
                  method: 'POST',
                  headers: { 'Authorization': `Bearer ${localStorage.getItem('DM_Admin_TOKEN')}` },
                  body: formData
                });

                if (response.ok) {
                  toast.success('Promo code deleted successfully');
                  getPromoList(); // Refresh the list after deletion
                } else {
                  console.error('Error deleting promo code');
                  toast.error('Failed to delete promo code');
                }
              } catch (err) {
                console.error(err);
                if (err?.response?.status === 401 || err?.response?.data?.code === 401) {
                  handleLogout(navigate);
                  return;
                }
              } finally {
                setShowDeleteAlert(false);
                setSelectedPromoId(null);
              }
            }}
            onCancel={() => {
              setShowDeleteAlert(false);
              setSelectedPromoId(null);
            }}
            focusCancelBtn
          />
        )}

        <div id="content" className="content">
          <ol className="breadcrumb float-xl-right">
            <li className="breadcrumb-item basePath ">
              <a href="javascript:;">Home</a>
            </li>
            <li className="breadcrumb-item active currentPath">
              Promo Code
            </li>
          </ol>
          <h1 className="page-header">Promo Code</h1>
          {/* Add New Promo Code Button */}
          <div className="d-flex justify-content-end mb-3">
            <Button
              variant="primary"
              onClick={handleShowModal}
              style={{ backgroundColor: '#05ac93', borderColor: '#05ac93' }}
            >
              <i className="fa fa-plus mr-2"></i>
              Add New Promo Code
            </Button>
          </div>

          <br />

          {!Loading ? (
            <div
              style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '20px',
                marginTop: '10px',
              }}
            >
              <div className="row w-100">
                <div className="mb-3 col-12 text-center">
                  <div className="row">
                    <div className="col-xl-6 col-lg-6 col-sm-6 col-12 mb-3">
                      <div className="ml-0">
                        <div className="d-flex">
                          <h5 className="mt-2 mr-1">Search: </h5>
                          <Search
                            onSearch={(value) => {
                              setSearch(value);
                              setCurrentPage(1);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-sm-6 col-12 d-flex justify-content-end mb-3">
                      <div
                        style={{
                          color: 'black',
                          fontSize: '12px',
                          fontWeight: '300',
                          paddingTop: '0px',
                          paddingBottom: '0px',
                        }}
                        className="align-self-center"
                      >
                        <b>Rows per page :&nbsp;</b>
                      </div>
                      <div className="align-self-center">
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="none"
                            id="dropdown-basic"
                            style={{
                              cursor: 'auto',
                              backgroundColor: 'white',
                              borderColor: '#d5dbe0',
                              paddingBottom: '3px',
                              paddingTop: '3px',
                            }}
                          >
                            {limit}&nbsp;<i className="fa fa-caret-down"></i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {limit !== 10 ? (
                              <>
                                <Dropdown.Item
                                  onClick={() => {
                                    setlimit(10);
                                  }}
                                >
                                  10
                                </Dropdown.Item>
                              </>
                            ) : null}

                            {limit !== 20 ? (
                              <>
                                <Dropdown.Item
                                  onClick={() => {
                                    setlimit(20);
                                  }}
                                >
                                  20
                                </Dropdown.Item>
                              </>
                            ) : null}

                            {limit !== 30 ? (
                              <>
                                <Dropdown.Item
                                  onClick={() => {
                                    setlimit(30);
                                  }}
                                >
                                  30
                                </Dropdown.Item>
                              </>
                            ) : null}

                            {limit !== 50 ? (
                              <>
                                <Dropdown.Item
                                  onClick={() => {
                                    setlimit(50);
                                  }}
                                >
                                  50
                                </Dropdown.Item>
                              </>
                            ) : null}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-12">
                      <div className="table-responsive">
                        <Table striped bordered hover>
                          <thead>
                            <TableHeader
                              headers={userHeader}
                              onSorting={(field, order) =>
                                setSorting({ field, order })
                              }
                            />
                          </thead>
                          <tbody>
                            {commentsData.map((e, i) => (
                              <tr>
                                <>
                                  <td>{e?.sr_no}</td>
                                  <td>{e?.promoCode}</td>
                                  <td>{e?.discountType === "Flat"
                                    ? `$${e?.discount}`
                                    : e?.discountType === "Percentage"
                                      ? `${e?.discount}%`
                                      : "-"}</td>
                                  <td>{e?.promoType == 1 ? e?.foundation : "N/A"}</td>
                                  <td>{e?.totalDonation?.toFixed(2) || "N/A"}</td>
                                  <td>{e?.totalDiscount?.toFixed(2) || "N/A"}</td>
                                  <td>{moment(e?.startTime).format('lll')}</td>
                                  <td>{moment(e?.expiryTime).format('lll')}</td>
                                  <td >
                                    <>
                                      <i
                                        className="fa fa-edit mr-2"
                                        disabled={new Date(e.startTime) <= new Date()}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                          if (new Date(e.startTime) > new Date()) { handleEdit(e) }
                                          else {
                                            toast.error("You cannot edit this promo code as it has already started.");
                                          }
                                        }}
                                      />
                                      <i
                                        className="fa fa-trash"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleDelete(e._id)}
                                      />
                                      <i
                                        className="fa fa-history ml-2"
                                        style={{ cursor: 'pointer', color: '#000000' }}
                                        title="View Usages"
                                        onClick={() => handleViewUsages(e)}
                                      />
                                    </>
                                  </td>
                                </>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        {commentsData.length == 0 ? (
                          <div className="row d-flex justify-content-center w-100">
                            <div className="mx-auto  d-flex justify-content-center w-100">
                              <img
                                src="./assets/img/icon/no-location.png"
                                className="form-img__img-preview"
                                style={{ width: '100px', height: '100px' }}
                                alt=""

                              />
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div
                    className="mt-2 d-flex justify-content-sm-center justify-content-xs-center justify-content-lg-end"
                    style={{
                      overflowX: 'auto',
                    }}
                  >
                    <Pagination
                      total={totalItems}
                      itemsPerPage={limit}
                      currentPage={currentPage}
                      onPageChange={(page) => setCurrentPage(page)}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Spinner />
          )}
        </div>

        <Footer />
      </div>

      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header
          style={{
            backgroundColor: '#f8f9fa',
            border: 'none',
            paddingBottom: '15px'
          }}
        >
          <Modal.Title style={{ color: '#2c3e50', fontWeight: '600', fontSize: '18px' }}>
            {editMode ? 'Edit Promo Code' : 'Create New Promo Code'}
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleCloseModal}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '30px',
              fontWeight: 'bold',
              color: '#6c757d',
              cursor: 'pointer',
              position: 'absolute',
              right: '15px',
              top: '5px'
            }}
          >
            ×
          </button>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body style={{ padding: '30px' }}>
            <p style={{ color: '#6c757d', marginBottom: '25px' }}>
              {editMode ? 'Edit the promotional code details below.' : 'Add a new promotional code with foundation support'}
            </p>

            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: '500', color: '#2c3e50' }}>
                Promo Code *
              </Form.Label>
              <Form.Control
                type="text"
                name="promoCode"
                value={formData.promoCode}
                onChange={handleInputChange}
                placeholder="SAVE20"
                style={{
                  borderRadius: '8px',
                  border: '1px solid #e0e6ed',
                  padding: '12px 15px'
                }}
                required
              />
            </Form.Group>

            <div className="row">
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: '500', color: '#2c3e50' }}>
                    Discount *
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="discount"
                    value={formData.discount}
                    min={0}
                    onChange={handleInputChange}
                    placeholder="20"
                    style={{
                      borderRadius: '8px',
                      border: '1px solid #e0e6ed',
                      padding: '12px 15px'
                    }}
                    required
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: '500', color: '#2c3e50' }}>
                    Type *
                  </Form.Label>
                  <div style={{ position: 'relative' }}>
                    <Form.Select
                      name="discountType"
                      value={formData.discountType}
                      onChange={handleInputChange}
                      style={{
                        borderRadius: '8px',
                        border: '1px solid #e0e6ed',
                        padding: '12px 15px',
                        paddingRight: '40px',
                        appearance: 'none',
                        backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%236b7280\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'M6 8l4 4 4-4\'/%3e%3c/svg%3e")',
                        backgroundPosition: 'right 12px center',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '16px'
                      }}
                    >
                      <option value="Percentage">Percentage</option>
                      <option value="Flat">Flat</option>
                    </Form.Select>
                  </div>
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: '500', color: '#2c3e50' }}>
                    Promo Type *
                  </Form.Label>
                  <div style={{ position: 'relative' }}>
                    <Form.Select
                      name="promoType"
                      value={formData.promoType}
                      onChange={handleInputChange}
                      style={{
                        borderRadius: '8px',
                        border: '1px solid #e0e6ed',
                        padding: '12px 15px',
                        paddingRight: '40px',
                        appearance: 'none',
                        backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%236b7280\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'M6 8l4 4 4-4\'/%3e%3c/svg%3e")',
                        backgroundPosition: 'right 12px center',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '16px'
                      }}
                    >
                      <option value="1">Foundation</option>
                      <option value="2">General</option>
                    </Form.Select>
                  </div>
                </Form.Group>
              </div>
            </div>

            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: '500', color: '#2c3e50' }}>
                Foundation *
              </Form.Label>
              <Form.Control
                type="text"
                name="foundation"
                value={formData.foundation}
                disabled={formData.promoType !== '1'}
                onChange={handleInputChange}
                placeholder="Children's Health Foundation"
                style={{
                  borderRadius: '8px',
                  border: '1px solid #e0e6ed',
                  padding: '12px 15px'
                }}
                required
              />
            </Form.Group>

            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: '500', color: '#2c3e50' }}>
                    Start Time *
                  </Form.Label>
                  <Form.Control
                    type="datetime-local"
                    name="startDate"
                    value={formData.startDate}
                    onChange={handleInputChange}
                    style={{
                      borderRadius: '8px',
                      border: '1px solid #e0e6ed',
                      padding: '12px 15px'
                    }}
                    required
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: '500', color: '#2c3e50' }}>
                    End Time *
                  </Form.Label>
                  <Form.Control
                    type="datetime-local"
                    name="expiryDate"
                    value={formData.expiryDate}
                    onChange={handleInputChange}
                    style={{
                      borderRadius: '8px',
                      border: '1px solid #e0e6ed',
                      padding: '12px 15px'
                    }}
                    required
                  />
                </Form.Group>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ border: 'none', padding: '20px 30px' }}>
            <Button
              type="submit"
              disabled={modalLoading}
              style={{
                backgroundColor: '#05ac93',
                borderColor: '#05ac93',
                borderRadius: '8px',
                padding: '12px 30px',
                fontWeight: '500',
                width: '100%'
              }}
            >
              {modalLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                  {editMode ? 'Updating...' : 'Creating...'}
                </>
              ) : (
                editMode ? 'Update Promo Code' : 'Create Promo Code'
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={showUsagesModal} onHide={() => setShowUsagesModal(false)} centered size="lg">
        <Modal.Header>
          <Modal.Title>Usages for Promo Code: {usagesPromoCode}</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleCloseModal}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '30px',
              fontWeight: 'bold',
              color: '#6c757d',
              cursor: 'pointer',
              position: 'absolute',
              right: '15px',
              top: '5px'
            }}
          >
            ×
          </button>
        </Modal.Header>
        <Modal.Body>
          {usagesLoading ? (
            <Spinner />
          ) : usagesData.length === 0 ? (
            <div>No usages found for this promo code.</div>
          ) : (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>User</th>
                  <th>Job</th>
                  <th>Driver</th>
                  <th>Final Bid</th>
                  <th>Service Fee</th>
                  <th>Insurance</th>
                  <th>Discount</th>
                  <th>Donation</th>
                  <th>Total Paid</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {usagesData.map((usage, idx) => (
                  <tr key={usage.id || idx}>
                    <td>
                      {usage.user_id?.first_name} {usage.user_id?.last_name}
                    </td>
                    <td>
                      {usage.job_id?.item_description}
                    </td>
                    <td>
                      {usage.driver_id?.first_name} {usage.driver_id?.last_name}
                    </td>
                    <td>
                      {usage.paymentData?.final_bid_amount?.toFixed(2)}
                    </td>
                    <td>
                      {usage.paymentData?.service_fee?.toFixed(2)}
                    </td>
                    <td>
                      {usage.paymentData?.insurance_amount?.toFixed(2)}
                    </td>
                    <td>
                      {usage.paymentData?.discount_amount?.toFixed(2)}
                    </td>
                    <td>
                      {usage.paymentData?.donation_amount?.toFixed(2)}
                    </td>
                    <td>
                      {usage.paymentData?.total_paid_amount?.toFixed(2)}
                    </td>
                    <td>
                      {moment(usage.createdAt).format('lll')}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
